export class Evidencia {
  id_evidencia: number;
  abr: string;
  descripcion: string;
  articulado: string;
  codigo: string;
  periodicidad: string;
  periodicidadrecomendada: string;
  referencia: string;
  relevancia: number;
  riesgomax: any;
  riesgomin: any;
  infraccion: string;
  comentarios_infraccion: string;
  id_norma: number;
  id_modev: number;
  id_persmaq: number;
  id_asignacion: number;
  id_nivelelemento: number;
  id_nivelseguridad: number;
  comentarios: any=[];
  preaviso: string;
  moduloevidenciadesc: string;
  afpermaqdesc: string;
  asignaciondesc: string;
  nivelelementodesc: string;
  nivelseguridaddesc: string;
  id_tipo_sancion: number;
  tiposanciondesc: string;
  norma: string;
  bloque: string;
  area: string;
  modulo: string;
  modoexplicito: number;
  periodicidadtipo: number;
  actividades: any;
  evidenciasasociadas: any;

  //campos de Penal
  proceso: any;
  subproceso: any;
  sociosnegocio: any;
  directivos: any;
  empleados: any;
  areasdelito: any;
  riesgo: any;
  control: any;
  comportamiento: any;
  id_control: any;
  norma_comentarios_publicos: any;
  norma_comentarios_internos: any;
  sanciondisciplinaria: string = "";
  otrasconsecuencias: string = "";
  norma_enlace: any;
  norma_articulado: any;
  norma_referencia: any;

  causaperiodicidad: any;
  cuestioncondicionada: any;

  constructor(){
    this.id_evidencia = 0;
    this.abr = "";
    this.descripcion = "";
    this.articulado = "";
    this.codigo = "";
    this.periodicidad = "";
    this.periodicidadrecomendada = "";
    this.referencia = "";
    this.relevancia = -1;
    this.riesgomax = 0;
    this.riesgomin = 0;
    this.infraccion = "";
    this.comentarios_infraccion = "";
    this.id_norma = 0;
    this.id_modev = 1;
    this.id_persmaq = 0;
    this.id_asignacion = 1;
    this.id_nivelelemento = 1;
    this.id_nivelseguridad = 1;
    this.preaviso = "";
    this.moduloevidenciadesc = "";
    this.afpermaqdesc = "";
    this.asignaciondesc = "";
    this.nivelelementodesc = "";
    this.nivelseguridaddesc = "";
    this.id_tipo_sancion = 0;
    this.tiposanciondesc = "";
    this.norma = "";
    this.bloque = "";
    this.area = "";
    this.modulo = "";
    this.modoexplicito = 1;
    this.periodicidadtipo = 1;
    this.evidenciasasociadas = [];
    this.id_control = 0;
    this.directivos = 0;
    this.empleados = 0;
    this.sociosnegocio = 0;
    this.norma_enlace = "";
    this.norma_articulado = "";
    this.norma_referencia = "";
    this.causaperiodicidad = "";
    this.cuestioncondicionada = "";
  }

}



// WEBPACK FOOTER //
// ./src/app/_models/evidencia.model.ts